"use client";

import posthog from "posthog-js";

type RedditEvent = "SignUp" | "Lead" | "PublishChapter";

export function trackRedditEvent(event: RedditEvent): void {
    if (typeof window === "undefined" || !window.rdt) return;
    if (event === "PublishChapter") {
        window.rdt("track", "Custom", { customEventName: event });
    } else {
        window.rdt("track", event);
    }
}

export function captureClientEvent(event: string, properties?: Record<string, unknown>): void {
    if (posthog.__loaded) posthog.capture(event, properties);
}
